import firebase from '@/firebase/firestore';
import store from "@/store";

export default {
  addProject(createdAt, userId,projectname,why,phase,callout, isPublic){
    store.commit('setAddShow', false)
    let slug = String(this.generateUUID())
    const uid = String(userId)
    let addData = {
      createdAt: createdAt,
      userId: userId,
      projectname: projectname,
      why: why,
      phase: phase,
      callout: callout,
      slug: slug,
      isPublic: isPublic,
    }
    // Add to user's project doc with id of slug
    const db = firebase.firestore().collection("user")
    .doc(uid).collection("projects").doc(slug); // "Project"という名前のコレクションへの参照を作成   
    db.set(addData)
      .then(function () { // function (docRef)
        console.log('Document written with ID: ', slug);
        alert('Well done! You have created a new project!');
      })
      .catch(function (error) {
        console.error('Error adding document: ', error);
      });
      // Add project ID to users project id array
      firebase.firestore().collection("user").doc(uid).update({
        projectId: firebase.firestore.FieldValue.arrayUnion(slug)
      });
    // Add to project to project collection with id of slug
    // firebase.firestore().collection("projects").doc(slug).set(addData)
    
  },
  editProject(slug, editedAt, createdAt, userId,projectname,why,phase,callout, isPublic){
    store.commit('setAddShow', false)
    const uid = String(userId)
    let addData = {
      createdAt: createdAt,
      editedAt: editedAt,
      userId: userId,
      projectname: projectname,
      why: why,
      phase: phase,
      callout: callout,
      slug: slug,
      isPublic: isPublic,
    }
    // Add to user's project doc with id of slug
    const db = firebase.firestore().collection("user")
    .doc(uid).collection("projects").doc(slug); // "Project"という名前のコレクションへの参照を作成   
    db.set(addData)
      .then(function () { // function (docRef)
        console.log('Document edited with ID: ', slug);
        alert('Well done! You have edited a project!');
      })
      .catch(function (error) {
        console.error('Error adding document: ', error);
      });
  },
  generateUUID() {
    let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  },
  deleteProject(userId, slug) {
    // Remove from array of projectId from user collection
    firebase.firestore().collection("user").doc(userId).update({
      projectId: firebase.firestore.FieldValue.arrayRemove(slug)
    });
    
    // Remove Project itself from projects collection
    const db = firebase.firestore().collection('user').doc(userId)
      .collection('projects').doc(slug);
    db.delete().then(
      alert('You have deleted the project!' + slug)
    );

    // Delete project from project collection with id of slug
    // firebase.firestore().collection("projects").doc(slug).delete();
      // .get()
      // .then((snapshot) => {
        // snapshot.forEach((doc => {
          // console.log(doc.data().slug);
          // doc.ref.delete();
          // alert('You have deleted the project!' + doc.data().slug);
        // })) 
      // })
  },
};
